import React from 'react';

export const CommunityContext = React.createContext({});
